import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

/**
 * Consistent loading backdrop used across Coach Portal.
 * Shows a dark overlay with an hourglass and blocks all user interaction.
 *
 * @param {boolean} open - Whether the backdrop is visible
 * @param {React.ReactNode} [children] - Optional content shown below the hourglass
 */
export default function LoadingBackdrop({ open, children }) {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={open}>
      <HourglassEmptyIcon style={{ fontSize: 80 }} />
      {children}
    </Backdrop>
  );
}
